import { appConstants } from '../_constants';

//user's authentication state
let user = JSON.parse(localStorage.getItem(appConstants.AVI_USER_KEY));

export const initialState = {
    alert: {},
    modal: {},
    activity: {},
    api: {requesting : false, pageRequesting : false},
    user:  user ? { loggedIn: true, user } : {},
    users: null,
    airlines: false,
    airlinesCarriers: false,
    airports: false,
    countries: false,
    desAirports: false,
    depAirports: false,
    flightDays: false,
    dashboard: false,
    invoice: false,
    ftpCredentials: false,
    workFlowProcess: null,
    entities: false,
    airlineLocations: null,
    flagMetrics: false,
    ticketClass: false,
    ticketCategory: false
};



// WEBPACK FOOTER //
// ./src/_helpers/initialState.js